module.exports = __webpack_public_path__ + "img/51.0456f669.png";